import restApi from "../../http.js";
import env from "../../env.js";

export default class FormApi {
  emailCapture(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appKxvVcmj2w1rzOL/signups",
      data: {
        fields: {
          "Email Address": request.emailAddress,
          Type: request.type,
        },
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }
  submitHubspotEmail(data) {
    return restApi({
      method: "POST",
      url: `https://api.hsforms.com/submissions/v3/integration/submit/6694100/aee4cdca-0666-412b-b1b1-469b8883e866`,
      data: data,
    });
  }

  hubspotCreateUser(data) {
    return restApi({
      method: "POST",
      url: `https://api.hsforms.com/submissions/v3/integration/submit/6694100/421f1b5e-63a6-411b-9f14-d0d5147ea901`,
      data: data,
    });
  }

  applyAsBrand(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appIBXLpnALIlQdUy/Brand%20Intake",
      data: {
        fields: {
          "Brand Name": request.brandName,
          "Brand Website": request.brandWebsite,
          "Brand Instagram": request.brandInstagram,
          City: request.city,
          "Contact Name": request.contactName,
          "Contact Email": request.email,
          "Shipping From": request.shippingFrom,
          "Selected Category": request.productCategory,
          "Avg Inventory Time": request.leadTime,
          "Avg Quantity Minimums": request.quantityMinimums,
          "Product Customization for Partners": request.productCustomization,
          "Top 5 Bestsellers":
            request.bestSeller1 +
            " | " +
            request.bestSeller2 +
            " | " +
            request.bestSeller3 +
            " | " +
            request.bestSeller4 +
            " | " +
            request.bestSeller5,
          Notes: request.notes,
        },
      },

      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  applyAsRetailer(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appEoxSCYmyvmy84A/Retailer-Partner%20Intake",
      data: {
        fields: {
          "Retailer name": request.retailerName,
          "Location / delivery address": request.location,
          "Inventory arrival date": request.arrivalDate,
          "What are you trying to accomplish with this assortment?":
            request.assortmentGoal === "Other" ? "Other: " + request.assortmentGoalOther : request.assortmentGoal,
          "Number of styles you are requesting": request.numberOfStyles,
          "Volume of inventory you are requesting": request.volumeOfInventory,
          "Category focus": request.categoryFocus,
          "What kind of neighborhood is your shop in and what is your typical customer like?": request.typicalCustomer,
          Age: request.age,
          Gender: request.gender,
          "Average annual income": request.annualIncome,
          "How does your customer typically find out about you?":
            request.typicalFindOut === "Other" ? "Other: " + request.typicalFindOutOther : request.typicalFindOut,
          "What kind of brands does your customer shop?": request.kindOfBrands,
          "What are your top performing categories?": request.topPerformingCategories,
          "Do you have a lot of individual shoppers or do customers tend to come in groups?": request.customerGroups,
          "Average order value in-store": request.averageOrderValueStore,
          "Average order value online": request.averageOrderValueOnline,
          "Top performing product categories": request.topProductCategories,
          "Lowest performing product categories": request.lowProductCategories,
          "Popular themes/motifs": request.popularThemes,
          "Most expensive price point": request.mostExpensivePrice,
          "Least expensive price point": request.leastExpensivePrice,
          "Okay with expletives": request.expletives,
          "Okay with sex positive messaging": request.messaging,
          "Okay with celebrity likeness": request.celebrity,
          "Okay with CBD product": request.cbd,
          "Okay with Political/Social product": request.political,
          "Categories you don’t want": request.unwantedCategories,
          "Maximum price point": request.maximumPricePoint,
          "Minimum price point": request.minimumPricePoint,
          "Female-founded brands only": request.femaleBrands,
          "How did you hear about Bulletin?": request.notes,
        },
      },

      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  requestAssortment(model) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appwfEjbvl2b5IEGk/Applications",
      data: {
        fields: {
          "First Name": model.firstName,
          "Last Name": model.lastName,
          "Brand Name": model.brandName,
          Instagram: model.instagram,
          "Email address": model.emailAddress,
          "Phone Number": model.phoneNumber,
          Website: model.website,
          "Product Category": model.productCategory,
          "Stores you are selling": model.sellStores,
          "Hear about Bulletin": model.hearAboutBulletin,
          "work link": model.url,
        },
      },

      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }
  postToJobBoard(model) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appiUaGKbuDBfyhA8/Job%20Applications",
      data: {
        fields: {
          "Applied For": model.jobPosition.name,
          Name: `${model.first_name} ${model.last_name}`,
          "Email Address": model.email_address,
          "Phone Number": model.phone_number,
          "Did anyone refer you?": model.refer,
          "How did you hear about Bulletin?": model.how_did_you_hear,
          Linkedin: model.linkedin,
          "Anything Else": model.anything_else,
          CV: model.url,
        },
      },

      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  subscribe(model) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appqnN6xXdJMZ8fmd/Subscribers",
      data: {
        fields: {
          "Email Address": model.email,
        },
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  brandSignupAirtable(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/app4c3utHfi5F5A1q/Table%201",
      data: {
        fields: {
          Email: request.email,
          Firstname: request.first_name,
          Lastname: request.last_name,
          "Brand Name": request.brand_name,
          "Brand URL": request.website_url,
          "Years In Business": request.years_in_business.toString(),
          Location: request.location,
          "UTM Medium": request.utm_medium,
          "UTM Source": request.utm_source,
          "UTM Campaign": request.utm_campaign,
          Date: new Date().toDateString(),
        },
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }

  sendConfirmedOrderAirtable(request) {
    return restApi({
      method: "post",
      url: "https://api.airtable.com/v0/appmQqLAgG7O2u2aO/Table%201",
      data: {
        fields: {
          Products: request.products,
          "Submitted Order Value": request.total,
          "Submitted Suborder Value": request.suborder_total,
          "Shipping Address": request.address,
          "Order Number": request.order_number,
          "Suborder Number": request.suborder_number,
          "Retailer Store Name": request.retailer_name,
          "Brand Company Name": request.brand_name,
          "Retailer Email": request.retailer_email,
          Date: request.date,
          "Promo Code": request.promo_code,
          "Promo Code Value": request.promo_code_value,
          "Referring Brand": request.referring_brand,
        },
        typecast: true,
      },
      headers: {
        Authorization: "Bearer " + env.airTableToken(),
      },
    });
  }
}
